import { Resource } from './resource';
import gql from 'graphql-tag';

export class RoleResource extends Resource {
  public static async list() {
    return await this.query(
      {
        query: gql`
          query {
            roles {
              id
              displayName
            }
          }
        `
      },
      'roles'
    );
  }

  public static async addRoleToUser(userId: number, roleId: number) {
    return await this.mutation(
      {
        mutation: gql`
          mutation($userId: Int!, $roleId: Int!) {
            addRoleToUser(userId: $userId, roleId: $roleId) {
              firstName
              roles {
                id
                displayName
              }
            }
          }
        `,
        variables: { userId, roleId }
      },
      'addRoleToUser'
    );
  }

  public static async removeRoleFromUser(userId: number, roleId: number) {
    return await this.mutation(
      {
        mutation: gql`
          mutation($userId: Int!, $roleId: Int!) {
            removeUserRole(userId: $userId, roleId: $roleId) {
              roles {
                id
                displayName
              }
            }
          }
        `,
        variables: { userId, roleId }
      },
      'removeUserRole'
    );
  }
}
